class FileUploadController {
    constructor(_, componentRegistryService, $q, Upload ) {
        this.vm = {
            errors: []
        };

        this._ = _;
        this.upload = Upload;
        this.maxFileSize = 15;
        this.validFileExtensions = ["doc", "docx", "pdf", "xls", "xlsx", "msg"];
        this.baseInvalidExtensionErrorMsg =
            `Please attach a valid file: ".${this.validFileExtensions.join('", ".')}"`;    
    }

    init() {
        this.vm = {
            errors: [] 
        };
    }

    onUpload(file) {     
        this.clearErrors();
        if (this.isValid(file)) {          
            this.onFileUpload({ disclosureFile: file });            
            this.clearField();
        }
    }  

    isValid(file) {
        if (this.fileAttached(file) && this.hasValidFileExtension(file) && this.hasValidFileSize(file)) {
            return true;
        }
        return false;
    }

    fileAttached(file) {
        if (!file) {
            this.vm.errors.push(this.baseInvalidExtensionErrorMsg);         
            return false;
        }
        return true;
    }

    hasValidFileExtension(file) {
        let hasValidFileExtension = this.validFileExtensions.some(function (validExtension) {
            return file.name.split(".").pop() === validExtension;
        });

        if (!hasValidFileExtension) {
            this.vm.errors.push(this.baseInvalidExtensionErrorMsg);
        }
        return hasValidFileExtension;
    }

    hasValidFileSize(file) {
        let hasValidFileSize = file.size <= 15728640;
        if (!hasValidFileSize) {
            this.vm.errors.push(`Attachments must be smaller than 15MB`);
        }
        return hasValidFileSize;
    }
   
    clearField() {
        this.disclosureFile = null;
    }

    clearErrors() {
        this.vm.errors = [];
    }
}

FileUploadController.$inject = ['_', 'componentRegistryService', '$q', 'Upload'];

export default {
    controller: FileUploadController,
    bindings: {
        fileName: '@',
        modelName: '@',
        readonly: '<',
        onFileUpload: '&'
    },
    templateUrl: `app/components/file-upload/file-upload.html`
};


// WEBPACK FOOTER //
// ./app/components/file-upload/file-upload.component.js